import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactSectionV2 from "../../componentsPeopletech/v2/ContactSectionV2";
import Footer from "../../componentsPeopletech/Footer/Footer";

const BASE_PATH = '/peoplefortech/v2';

const ContactPeopleV2 = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  const baseUrl = 'https://www.peoplefortech.com';
  const v2ContactUrl = `${baseUrl}${BASE_PATH}/contact`;

  return (
    <>
      <Helmet>
        <title>{t('nav.contact')} - PeopleForTech v2</title>
        <meta name="description" content={`${t('contact.title')} - ${t('contact.subtitle')}`} />
        <link rel="canonical" href={v2ContactUrl} />
        <html lang={currentLang} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={v2ContactUrl} />
        <meta property="og:title" content={`${t('nav.contact')} - PeopleForTech v2`} />
      </Helmet>
      <ContactSectionV2 />
      <Footer />
    </>
  );
};

export default ContactPeopleV2;
